import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {SLACK} from '../../constants';

import {SalesAutomationCardSlack} from '../cards/sales-automation-card-slack';

import {CardsContainer} from './cards-container';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    outcomeType: OutcomeType;
};

export class ClosedLeadSlackContainer extends React.PureComponent<Props> {
    render() {
        const automationsForOutcomeType = this.props.closedLeadAutomations.find(
            (automation) => automation.outcomeType === this.props.outcomeType
        );

        const slackCards = automationsForOutcomeType
            ? automationsForOutcomeType.slackAutomations.map((slackAutomation) => {
                  return (
                      <SalesAutomationCardSlack
                          key={slackAutomation.id}
                          parentId={this.props.outcomeType}
                          slackAutomation={slackAutomation}
                      />
                  );
              })
            : [];

        return (
            <CardsContainer
                type={SLACK}
                isCardBeingDragged={false} // Can't drag slack automations right now
                isLoading={this.props.isLoading}
                errorMessage={this.props.errorMessage}
                parentId={this.props.outcomeType}
                hideAddCard={false}
            >
                {slackCards}
            </CardsContainer>
        );
    }
}
